var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6987 36.2329H23C20.2386 36.2329 18 38.4715 18 41.2329V93.3334C18 105.3 27.7005 115 39.6667 115H80.032C91.9982 115 101.699 105.3 101.699 93.3334V41.2329C101.699 38.4715 99.4601 36.2329 96.6987 36.2329ZM23 31.2329C17.4772 31.2329 13 35.7101 13 41.2329V93.3334C13 108.061 24.9391 120 39.6667 120H80.032C94.7596 120 106.699 108.061 106.699 93.3334V41.2329C106.699 35.7101 102.222 31.2329 96.6987 31.2329H23Z",
    fill: "#424A52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.7983 31.2329V25.8317C80.7983 14.3267 71.4717 5 59.9667 5C48.4617 5 39.135 14.3267 39.135 25.8317V31.2329H34.135V25.8317C34.135 11.5652 45.7002 0 59.9667 0C74.2331 0 85.7983 11.5652 85.7983 25.8317V31.2329H80.7983Z",
    fill: "#424A52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4247 70.685C66.4247 74.3164 63.4808 77.2603 59.8493 77.2603C56.2179 77.2603 53.274 74.3164 53.274 70.685C53.274 67.0535 56.2179 64.1096 59.8493 64.1096C63.4808 64.1096 66.4247 67.0535 66.4247 70.685Z",
    fill: "#0086FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5617 73.9729C56.5617 72.1572 58.0336 70.6852 59.8493 70.6852C61.6651 70.6852 63.137 72.1572 63.137 73.9729V83.8359C63.137 85.6517 61.6651 87.1236 59.8493 87.1236C58.0336 87.1236 56.5617 85.6517 56.5617 83.8359V73.9729Z",
    fill: "#0086FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnLock);
export default __webpack_public_path__ + "static/media/icn-lock.7dcec8fbe10963e2c2fdc3484b69d6d9.svg";
export { ForwardRef as ReactComponent };